import { Button, Modal, Form, Input, Tooltip, DatePicker, Select } from 'antd';
import moment from 'moment';
import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useEffect, useState, useRef } from 'react';
import DataBreachService from '../../../../../services/DataBreach.service';
import useNotify from '../../../../../context/Notification/useNotify';

const { Option } = Select;

const ModalActionForm = ({
    open,
    title,
    loading,
    width = 135,
    confirmText = null,
    cancelText = null,
    setOpenActionPlanForm,
    actionId,
    id,
    setActionId,
    form
}) => {
    const { t, i18n } = useTranslation('data-breach');
    const [dueDate, setDueDate] = useState(moment());
    const [statusOptions, setStatusOptions] = useState([]);
    const [userOptions, setUserOptions] = useState([]);
    const [change, setChange] = useState(false);
    const notify = useNotify();
    const [actionData, setActionData] = useState([]);

    const disabledDueDate = (current) => {
        return current && current < moment().startOf('day'); 
    };

    const onFinish = (values) => {
        if (actionId) {
            const payload = {
                actionPlanId: actionId,
                actionPlanName: values.actionPlanName,
                dueDate: values.dueDate,
                responsiblePerson: values.responsiblePerson,
                status: values.status
            };
            DataBreachService.updateActionPlan(payload)
                .then((res) => {
                    if (res.data.resultMsg === 'SUCCESS') {
                        setOpenActionPlanForm(false);
                        setActionId(null);
                        // setOpenModalStatus(true);
                    } else {
                        setOpenActionPlanForm(false);
                        setActionId(null);

                    }
                })
                .catch((err) => {
                    notify({
                        type: 'error',
                        title: t('Fail'),
                        description: t('FailedtoSubmitData'),
                        closeable: true,
                        timeOut: 120000,
                    });
                });
        } else {
            const payload = {
                txnDataBreachId: id,
                actionPlanName: values.actionPlanName,
                dueDate: values.dueDate,
                responsiblePerson: values.responsiblePerson,
                status: values.status
            };
            DataBreachService.createActionPlan(payload)
                .then((res) => {
                    if (res.data.resultMsg === 'SUCCESS') {
                        setOpenActionPlanForm(false);
                        setActionId(null);
                        // setOpenModalStatus(true);
                    } else {
                        setOpenActionPlanForm(false);
                        setActionId(null);
                    }
                })
                .catch((err) => {
                    notify({
                        type: 'error',
                        title: t('Fail'),
                        description: t('FailedtoSubmitData'),
                        closeable: true,
                        timeOut: 120000,
                    });
                });
        }
    };

    useEffect(() => {
        const getStatusList = async () => {
            try {
                const { data } = await DataBreachService.getStatusActionList();
                if (data?.resultData) {
                    setStatusOptions(data?.resultData);
                }
            } catch (error) {
                console.log(error);
            }
        };
        const getUser = async () => {
            try {
                const { data } = await DataBreachService.getUserList();
                if (data?.resultData) {
                    setUserOptions(data?.resultData);
                }
            } catch (error) {
                console.log(error);
            }
        };
        const getActionPlanDetail = async (value) => {
            if (actionId !== null) {
                try {
                    const { data } = await DataBreachService.getActionPlanDetail(value);
                    if (data?.resultData) {
                        setActionData(data?.resultData);
                        form.setFieldsValue({
                            actionPlanName: data?.resultData.actionPlanName,
                            dueDate: data?.resultData.dueDate ? moment(data?.resultData.dueDate) : null,
                            responsiblePerson: data?.resultData.responsiblePerson,
                            status: data?.resultData.status,
                        });
                    }
                } catch (error) {
                    console.log(error);
                }
            } else {
                form.resetFields();
            }

        };
        getStatusList();
        getUser();
        getActionPlanDetail(actionId);
    }, [actionId]);

    const cancelForm = async () => {
        await setActionId(null)
        await form.resetFields();
        setOpenActionPlanForm(false)
    };

    return (
        <Modal
            width={455}
            className="_modal"
            footer={false}
            open={open}
            onCancel={() => cancelForm()}
            title={title}
        >
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                onFinish={onFinish}
                form={form}
                className="w-full"
                layout="vertical"
                onFieldsChange={(_, allFields) => {
                    if (allFields.length > 0) {
                        setChange(true);
                    }
                }}
            >

                <div className="action-plan">
                    <div className='flex justify-between w-full items-center pb-2'>
                        <span className="text-sm font-normal">
                            {t('Action plan name')} <span className="text-error">*</span>
                        </span>
                        <Tooltip
                            placement="right"
                            overlayClassName="min-w-[300px]"
                            title={parse(t('Action plan name tooltip'))}
                        >
                            <a className="bg-purple-light p-2 flex items-center justify-center rounded-lg text-purple">
                                <ExclamationCircleOutlined />
                            </a>
                        </Tooltip>
                    </div>
                    <Form.Item
                        label={
                            false
                        }
                        name="actionPlanName"
                        rules={[
                            {
                                required: true,
                                message: t(
                                    'requiredField'
                                ),
                            },
                        ]}
                    >
                        <Input
                            placeholder={t('Specify action name')}
                            size="large"
                            showCount
                            maxLength={150}
                        />
                    </Form.Item>
                    <div className='flex justify-between w-full items-center pb-2'>
                        <span className="text-sm font-normal">
                            {t('Operation Completion Date')} <span className="text-error">*</span>
                        </span>
                        <Tooltip
                            placement="right"
                            overlayClassName="min-w-[300px]"
                            title={parse(t('Due date tooltip'))}
                        >
                            <a className="bg-purple-light p-2 flex items-center justify-center rounded-lg text-purple">
                                <ExclamationCircleOutlined />
                            </a>
                        </Tooltip>
                    </div>
                    <Form.Item
                        label={
                            false
                        }
                        name="dueDate"
                        rules={[
                            {
                                required: true,
                                message: t(
                                    'requiredField'
                                ),
                            },
                        ]}
                    >
                        <DatePicker
                            style={{ width: '100%' }}
                            size="large"
                            format="DD/MM/YYYY"
                            onChange={(value) => {
                                setDueDate(value);
                            }}
                            disabledDate={disabledDueDate}
                            placeholder="DD/MM/YYYY"
                        />
                    </Form.Item>
                    <div className='flex justify-between w-full items-center pb-2'>
                        <span className="text-sm font-normal">
                            {t('Responsible person')} <span className="text-error">*</span>
                        </span>
                    </div>
                    <Form.Item
                        label={
                            false
                        }
                        name="responsiblePerson"
                        rules={[
                            {
                                required: true,
                                message: t(
                                    'requiredField'
                                ),
                            },
                        ]}
                    >
                        <Select
                            size="large"
                            className="w-full"
                            placeholder={t('Responsible person')}
                            optionFilterProp="children"
                        >
                            {userOptions.map((item) => (
                                <Select.Option
                                    key={item.userId}
                                    value={item.userId}
                                >
                                    {item.fullName}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <div className='flex justify-between w-full items-center pb-2'>
                        <span className="text-sm font-normal">
                            {t('Current Operation Status')} <span className="text-error">*</span>
                        </span>
                    </div>
                    <Form.Item
                        label={
                           false
                        }
                        name="status"
                        rules={[
                            {
                                required: true,
                                message: t(
                                    'requiredField'
                                ),
                            },
                        ]}
                    >
                        <Select
                            size="large"
                            className="w-full"
                            placeholder={t('Current Operation Status')}
                            optionFilterProp="children"
                        >
                            {statusOptions.map((item) => (
                                <Option key={item.statusId} value={item.statusId}>
                                    {i18n.language === 'en' ? item.nameEn : item.nameTh}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </div>
                <div className="flex justify-center items-center space-x-4">
                    <>
                        <Button
                            style={{ width }}
                            type="primary"
                            onClick={() => setOpenActionPlanForm(false)}
                            size="large"
                            ghost
                            className="w-36"
                        >
                            {cancelText ? cancelText : t('Cancel')}
                        </Button>
                        <Button
                            style={{ width }}
                            loading={loading}
                            // onClick={handelOk}
                            size="large"
                            htmlType="submit"
                            type="primary"
                            className="w-36"
                        >
                            {confirmText ? confirmText : t('Save')}
                        </Button>

                    </>
                </div>
            </Form>

        </Modal>
    );
};
export default ModalActionForm;
